<script lang="ts">
    import { onMount } from "svelte"
    import MedialibImage from "../../widgets/MedialibImage.svelte"
    import MediaQuery from "../../widgets/MediaQuery.svelte"
    import { animateOnVisible } from "../../../configs/config"
    let { block }: { block: PeopleSliderBlock } = $props()
    const cnt = block.content

    let activeSlide = $state(0)
    function nextSlide() {
        if (activeSlide < cnt.slides.length - 1) activeSlide += 1
        else activeSlide = 0
    }

    function prevSlide() {
        if (activeSlide > 0) activeSlide -= 1
        else activeSlide = cnt.slides.length - 1
    }

    let h2El = $state(null)
    let pEl = $state(null)
    onMount(() => {
        const commonProps = {
            duration: 300,
            opacity: [0, 1],
            easing: "cubicBezier",
        }

        animateOnVisible(pEl, {
            delay: 1000,
            ...commonProps,
        })

        animateOnVisible(h2El, {
            translateY: ["30px", "0rem"],
            scale: [0.7, 1],
            delay: 300,
            ...commonProps,
        })
    })
</script>

{#snippet staticText()}
    <section class="upper-content">
        <h2 class="h1" bind:this={h2El}>
            {block.content.slider_title}
        </h2>
        <p bind:this={pEl}>
            {block.content.description}
        </p>
    </section>
{/snippet}

<section class="people-slider">
    <MediaQuery query="(max-width: 1023px)">
        {#snippet contentSnippet()}
            {@render staticText()}
        {/snippet}
    </MediaQuery>
    <ul class="images">
        {#each cnt.slides as slide, idx}
            <li class:active={idx === activeSlide} class="background-img">
                <MedialibImage class="mobile" id={slide.mobile_image[0]} maxWidth={600} />
                <MedialibImage class="desktop" id={slide.desktop_image[0]} maxWidth={2000} />
                <div class="fade"></div>
            </li>
        {/each}
    </ul>
    <div class="overlay">
        <div class="content">
            <MediaQuery query="(min-width: 1024px)">
                {#snippet contentSnippet()}
                    {@render staticText()}
                {/snippet}
            </MediaQuery>
            <section class="lower-content">
                <ul>
                    {#each cnt.slides as slide, idx}
                        <li class:active={idx === activeSlide} class="text">
                            <h3 class="h2">{slide.name}</h3>
                            <p>
                                {@html slide.description}
                            </p>
                        </li>
                    {/each}
                </ul>
                <div class="arrows">
                    <button class="scroll-button left" onclick={() => prevSlide()}>
                        <img src="/media/leftChev.svg" alt="arrow-left" />
                    </button>
                    <button class="scroll-button right" onclick={() => nextSlide()}>
                        <img src="/media/rightChev.svg" alt="arrow-right" />
                    </button>
                    <ul class="slide-tracking">
                        {#each cnt.slides as slide, idx}
                            <li class:active={idx === activeSlide}>
                                <button onclick={() => (activeSlide = idx)} aria-label="slide-tracker"></button>
                            </li>
                        {/each}
                    </ul>
                </div>
            </section>
        </div>
    </div>
</section>

<style lang="less" global>
    @import "../../../css/variables.less";
    section.people-slider {
        width: 100%;
        --people-overlay-max-width: clamp(450px, 46vw, 860px);
        --people-overlay-horizontal-gap: clamp(1.2rem, 4vw, 2.4rem);
        /* Skalierungsfaktor: zwischen 1200px und 1920px linear von 0.75 (klein) auf 1.0 (groß) skalieren */
        --text-scale-factor: clamp(0.75, calc(0.75 + (100vw - 1200px) / 720px * 0.25), 1);

        scroll-snap-align: start;
        @media @header_desktop {
            height: calc(100vh - var(--header-height) + 18px);
        }
        position: relative;
        display: flex;
        justify-content: center;
        .upper-content {
            display: flex;
            flex-direction: column;
            gap: var(--people-overlay-horizontal-gap);
            width: 100%;
            max-width: 100%;
            margin-left: auto;

            background: var(--bg-200);
            padding: var(--default-padding);

            @media @header_desktop {
                padding: 0px;
                max-width: min(var(--people-overlay-max-width), calc(900px - (120px + 2.4rem)));
                margin-right: clamp(1.2rem, 5vw, 3.6rem);
                background: rgba(250, 246, 244, 0.8);
                padding: var(--numbers-spacings-spacing-xs, 6px) 72px var(--numbers-spacings-spacing-s, 12px)
                    var(--numbers-spacings-spacing-m, 24px);
                border-radius: 4px;
            }
            padding-bottom: 2.4rem;
            p {
                font-size: calc(clamp(1rem, 0.95rem + 0.6vw, 1.5rem) * var(--text-scale-factor));
            }
            .h1 {
                font-size: calc(clamp(1.6rem, 1.2rem + 1vw, 2.4rem) * var(--text-scale-factor));
                line-height: 120%;
            }
        }
        ul.images {
            width: 100%;
            height: 100%;
            position: relative;
            max-width: 3560px;
            width: 100vw;
            min-height: 100vh;
            height: 100vh;
            @media @header_desktop {
                width: 100%;
                height: 100%;
                min-height: initial;
            }
            @media @max-mobile {
                min-height: 50vh;
                height: 50vh;
            }
            li {
                opacity: 0;
                position: absolute;
                top: 0px;
                left: 0px;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: flex-start;

                picture {
                    height: 100%;
                    width: 100%;
                    object-fit: cover;
                    &.mobile-pic {
                        display: none;
                    }
                    img {
                        height: 100%;
                        width: 100%;
                        object-fit: cover;

                        object-position: 0 50%;
                    }
                }
                .fade {
                    position: absolute;
                    pointer-events: none;
                    top: 0px;
                    left: 0px;
                    height: 100%;
                    width: 100%;
                    background:
                        linear-gradient(0deg, rgba(225, 218, 213, 0) 87.5%, #e1dad5 100%),
                        linear-gradient(180deg, rgba(225, 218, 213, 0) 50%, #e1dad5 100%);
                    @media @header_desktop {
                        background: linear-gradient(270deg, #faf6f4 0%, rgba(250, 246, 244, 0) 60%);
                    }
                }
            }
            li.active {
                opacity: 1;
            }
        }
        .overlay {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        position: relative;
        flex-direction: column;

        @media @header_desktop {
            position: absolute;
            top: 0px;
            left: 0px;
                flex-direction: row;
            }
            & > .content {
                max-width: 1920px;
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-end;

                @media @header_desktop {
                    padding: 4.8rem var(--default-padding);
                }
                .lower-content {
                    display: flex;
                    width: 100%;
                    flex-direction: column;
                    gap: var(--people-overlay-horizontal-gap);
                    max-width: 100%;
                    margin-left: auto;
                    position: relative;
                    @media @header_desktop {
                        padding-bottom: clamp(2.8rem,8vw,10rem);
                    }
                    @media @header_desktop {
                        max-width: min(var(--people-overlay-max-width), 900px);
                        flex-direction: row;
                        gap: 2.4rem;
                    }

                    & > ul {
                        display: flex;
                        position: relative;
                        flex-grow: 1;
                        background: var(--bg-200);
                        padding: var(--default-padding);
                        padding-bottom: 2.4rem;
                        width: 100%;
                        max-width: 100%;
                        margin-left: auto;

                        @media @header_desktop {
                            padding: 0px;
                            background: rgba(250, 246, 244, 0.8);
                            border-radius: 4px;
                        }
                        @media @max-mobile {
                            height: 170px;
                        }
                        li {
                            border-left: 1px solid var(--brand-100);
                            transition:
                                opacity 0.3s ease-in-out,
                                padding-left 0.3s ease-in-out;
                            position: absolute;
                            padding: var(--numbers-spacings-spacing-xs, 6px) 1.2rem
                                var(--numbers-spacings-spacing-s, 12px) 24px;
                            top: 0px;
                            left: 0px;
                            width: 100%;
                            height: 100%;
                            opacity: 0;
                            display: flex;
                            flex-direction: column;
                            gap: 0.5rem;
                            h3.h2 {
                                font-size: calc(clamp(1.2rem, 1rem + 0.7vw, 2rem) * var(--text-scale-factor));
                                line-height: 130%;
                            }
                            p {
                                font-size: calc(clamp(1rem, 0.95rem + 0.3vw, 1.3rem) * var(--text-scale-factor));
                                line-height: 150%;
                            }
                            &.active {
                                position: relative;
                                opacity: 1;
                                z-index: 1;
                            }
                            &:hover {
                                p,
                                h3 {
                                    transform: translateX(1.2rem);
                                }
                            }
                        }
                    }
                    .arrows {
                        display: flex;
                        gap: 1.2rem;
                        align-items: flex-end;
                        overflow: hidden;
                        width: 100%;
                        height: 4.8rem;
                        padding: 1.2rem var(--default-padding);
                        @media @header_desktop {
                            position: absolute;
                            right: clamp(1.2rem, 3vw, 2.4rem);
                            bottom: clamp(1.2rem, 3vw, 2.4rem);
                            width: fit-content;
                            height: auto;
                            padding: 0px;
                            gap: 0.8rem;
                            background: transparent;
                        }
                        .slide-tracking {
                            background-color: var(--bg-100);
                            height: 100%;
                            display: flex;
                            align-items: center;
                            flex-grow: 1;

                            li {
                                height: 2px;
                                flex-grow: 1;
                                background: var(--dark-20);
                                &.active {
                                    background: var(--brand-100);
                                }
                                button {
                                    width: 100%;
                                    height: 100%;
                                    background: none;
                                    border: none;
                                    cursor: pointer;
                                }
                            }
                            @media @header_desktop {
                                display: none;
                            }
                        }
                    }
                }
            }
        }
        flex-direction: column;
        @media @header_desktop {
            flex-direction: row;
        }
    }
</style>
